<template>
  <div class="inline-banner-with-cta">
    <div class="inline-banner-with-cta__container">
      <div class="inline-banner-with-cta__description">
        {{ descriptionCopy }}
      </div>

      <button
        class="inline-banner-with-cta__cta button button--wide"
        :class="finalCtaJsClass"
        @click="handleClick"
        href="#">
        {{ finalCtaCopy }}
      </button>
    </div>
  </div>
</template>

<script>
import events from "/events/index";

export default {
  name: "InlineBannerWithCta",
  i18n: {
    messages: {
      en: {
        daysCount: " | one day | {count} days",
        monthsCount: " | one month | {count} months",
        description: "You can try Blinkist for free for {trialLength}. Don’t worry, if you cancel within the trial period you won’t be charged.",
        cta: "Start your free {count}-day trial"
      },
      de: {
        daysCount: " | 1 Tag | {count} Tage",
        monthsCount: " | 1 Monat | {count} Monate",
        description: "Damit du dir einen perfekten Eindruck machen kannst, kannst du Blinkist Premium {trialLength} kostenlos testen.",
        cta: "Jetzt Probeabo starten"
      }
    }
  },
  props: {
    ctaCopy: {
      type: String,
      default: null
    },
    ctaJsClass: {
      type: String,
      default: null
    },
    piwikCategory: {
      type: String,
      default: null
    },
    plan: {
      type: Object,
      default: null,
      validator: function (plan) {
        return typeof plan.trialDays === "number";
      }
    }
  },
  computed: {
    finalCtaCopy() {
      return this.ctaCopy || this.$t("cta", { count: this.plan.trialDays });
    },
    descriptionCopy() {
      let trialLength;

      if (this.plan.trialDays % 31 === 0) {
        trialLength = this.$tc("monthsCount", this.plan.trialDays / 31);
      } else {
        trialLength = this.$tc("daysCount", this.plan.trialDays);
      }

      return this.$t("description", { trialLength });
    },
    finalCtaJsClass() {
      return this.ctaJsClass || "js-open-signup-popup";
    }
  },
  methods: {
    handleClick() {
      events.track(this.piwikCategory, "1-click");
    }
  }
};
</script>

<style lang="scss">
.inline-banner-with-cta {

  &__container {
    display: flex;
    flex-direction: column;

    padding: $spacing-24;

    background-color: $background-blue;

    border-radius: $spacing-4;

    @include media(min-width, m) {
      flex-direction: row;
      align-items: center;

      padding: $spacing-24 $spacing-64;
    }
  }

  &__description {
    @include font-style(p);

    margin-right: $spacing-24;
    margin-bottom: $spacing-16;

    @include media(min-width, m) {
      margin-bottom: 0;
    }
  }

  &__cta {
    flex-shrink: 0;
  }
}
</style>
